// Phase 1.5 item #1 · Replay diff card
//
// Summary card under the 3-column overlay: length Δ, token Δ, latency Δ,
// verdict Δ (if verifier ran on both). Each delta colored green if
// improvement / red if regression / muted if neutral.
//
// Backend response shape (per langfuse_provider.replay_generation):
//   { original_output, original_tokens_in, original_tokens_out,
//     original_duration_ms, original_verdict,
//     replayed_output, replayed_tokens_in, replayed_tokens_out,
//     replayed_duration_ms, replayed_verdict, length_delta_chars }
//
// Per Phase 1 §5 invariant #3: NO cost numbers displayed (tokens OK,
// dollars NOT). The backend doesn't return cost so we can't accidentally
// surface it.
import React from "react";
import { COLORS } from "../../../theme/colors";

export function ReplayDiffCard({ result }) {
  if (!result) return null;
  const lengthDelta = result.length_delta_chars
    ?? ((result.replayed_output?.length || 0) - (result.original_output?.length || 0));
  const tokensDelta = (result.replayed_tokens_out || 0) - (result.original_tokens_out || 0);
  const latencyDelta = (result.replayed_duration_ms || 0) - (result.original_duration_ms || 0);

  return (
    <div style={{
      display: "flex", gap: 16, alignItems: "center",
      fontSize: 11, color: COLORS.text,
    }}>
      <div style={{ fontWeight: 700, color: COLORS.textMuted,
                    textTransform: "uppercase", letterSpacing: 0.4, fontSize: 9 }}>
        diff
      </div>
      <DeltaKV label="length" delta={lengthDelta} unit=" chars" />
      <DeltaKV label="completion" delta={tokensDelta} unit=" tokens" />
      <DeltaKV label="latency" delta={latencyDelta} unit="ms" preferLower />
      {result.original_verdict && result.replayed_verdict
        && result.original_verdict !== result.replayed_verdict && (
        <span style={{ fontSize: 10, color: COLORS.textMuted }}>
          verdict: {result.original_verdict} → {result.replayed_verdict}
        </span>
      )}
    </div>
  );
}

function DeltaKV({ label, delta, unit, preferLower = false }) {
  const sign = delta > 0 ? "+" : "";
  const isNeutral = delta === 0 || delta === null || delta === undefined;
  // Latency: lower = better; everything else: just report
  const color = isNeutral
    ? COLORS.textMuted
    : preferLower
      ? (delta < 0 ? "#10b981" : "#ef4444")
      : COLORS.text;
  return (
    <span>
      <span style={{ color: COLORS.textMuted }}>{label} </span>
      <span style={{ color, fontFamily: "monospace", fontWeight: 600 }}>
        {isNeutral ? "—" : `${sign}${delta}${unit}`}
      </span>
    </span>
  );
}
